import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[locale]/domain-search/page.tsx");
